module.exports = __webpack_public_path__ + "static/media/history.082d45f6.png";